// import { Component } from '@angular/core';
// import { MessageService, ConfirmationService, ConfirmEventType } from 'primeng/api';

// import { UsuarioSesion } from 'src/app/models/usuario-sesion.interface';
// import { HttpPaginacion, Paginar } from 'src/app/models/http-paginacion.interface';
// import { AdministradorService } from 'src/app/services/administrador.service';
// import { HttpErrorResponse } from '@angular/common/http';
// import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// import { BusqUsuario, HttpPaginacionBusqueda } from 'src/app/models/http-paginacion-busqueda.interface';
// @Component({
//   selector: 'app-administrador-usuarios',
//   templateUrl: './administrador-usuarios.component.html',
//   styleUrls: ['./administrador-usuarios.component.scss'],
//   providers: [MessageService, ConfirmationService]
// })
// export class AdministradorUsuariosComponent {
//   first: number = 0;
//   rows: number = 10;
//   totalRecords: number = 120;
//   usuariosPageInformacion: HttpPaginacion<UsuarioSesion> | undefined;
//   usuariosPage: UsuarioSesion[] = [];

//   usuarioPageInformacion: HttpPaginacionBusqueda<BusqUsuario> | undefined;
//   usuarioPage: BusqUsuario[] = [];

//   passwordForm!: FormGroup;
//   busquedaForm!: FormGroup;

//   showModalPassword: boolean = false;
//   constructor(private administradorService: AdministradorService, private fb: FormBuilder, private confirmationService: ConfirmationService, private messageService: MessageService) {
//     this.obtenerInformacion(1);

//     this.passwordForm = this.crearFormulario();
//     this.busquedaForm = this.createFormularioBusqueda();
//     this.obtenerInformacionUsuario(1);

//   }
//   crearFormulario(): FormGroup {
//     return this.fb.group({
//       nuevo_password: [null, Validators.required],
//       id: [null]
//     })
//   }
//   createFormularioBusqueda(): FormGroup {
//     return this.fb.group({
//       nombre: [null],
//     })
//   }

//   onSubmitPassword(): void {
//     let id = this.f['id'].value;
//     let nueva = this.f['nuevo_password'].value;
//     this.administradorService.setCambiarPassword(id, nueva).subscribe({
//       next: (resp) => {
//         this.showSuccess(resp.mensaje);
//         this.cancelarAccion();
//       }, error: (err) => { this.showError(err.error.message); }
//     })
//   }
//   obtenerInformacion(page: number): void {
//     this.administradorService.usuarios(page)
//       .subscribe({
//         next: (resp) => {
//           this.usuariosPageInformacion = resp;
//           this.usuariosPage = resp.data;

//           this.first = (resp.current_page - 1) * resp.per_page;
//           this.rows = resp.per_page;
//           this.totalRecords = resp.total;
//         },
//         error: (err) => console.log(err)
//       })
//   }

//   onPageChange(event: any): void {
//     const paginar: Paginar = <Paginar>event;
//     const paginaActual = paginar.page + 1;
//     this.obtenerInformacionUsuario(paginaActual);
//     //console.log(this.first/ this.rows, event);
//   }
//   onSubmitBusqueda(): void {

//     this.obtenerInformacionUsuario(1);
//   }
//   obtenerInformacionUsuario(page: number): void {
//     const busqueda = this.busquedaForm.value;
//     this.administradorService.busquedaUsuarios(busqueda, page)
//       .subscribe({
//         next: (resp) => {

//           this.usuarioPageInformacion = resp;
//           this.usuarioPage = resp.data;
//           this.first = (resp.current_page - 1) * resp.per_page;
//           this.rows = resp.per_page;
//           this.totalRecords = resp.total;
//         },
//         error: (err) => console.log(err)
//       })
//   }
//   mensaje(usuario: UsuarioSesion): void {
//     alert(usuario.nom_completo)
//   }

//   confirmacion(usuario: UsuarioSesion): void {
//     this.confirmationService.confirm({
//       message: `Estas seguro que quieres desactivas a ${usuario.nom_completo}`,
//       header: 'Confirmacion',
//       icon: 'pi pi-exclamation-triangle',
//       accept: () => {

//         this.administradorService
//           .desactivarUsuario(usuario.id)
//           .subscribe({
//             next: (resp) => {
//               usuario.activo = 0;
//               this.messageService.add({ severity: 'info', summary: 'Confirmacion', detail: resp.mensaje });
//             },
//             error: (err: HttpErrorResponse) => { this.messageService.add({ severity: 'error', summary: 'Rechazada', detail: err.error.message }); }
//           })

//         // 
//       },
//       reject: (type: any) => {
//         switch (type) {
//           case ConfirmEventType.REJECT:
//             this.messageService.add({ severity: 'error', summary: 'Rechazada', detail: 'Confirmacion rechazada' });
//             break;
//           case ConfirmEventType.CANCEL:
//             this.messageService.add({ severity: 'warn', summary: 'Cancelada', detail: 'Opcion Cancelada' });
//             break;
//         }
//       }
//     });
//   }

//   cancelarAccion(): void {
//     this.resetForm();
//     this.closeModal();
//   }
//   closeModal(): void {
//     this.showModalPassword = false;
//   }
//   openModal(): void {

//     this.showModalPassword = true;
//   }
//   cambiarPassword(usuario: UsuarioSesion): void {
//     this.openModal();
//     this.f['id'].setValue(usuario.id);
//   }
//   resetForm(): void {
//     this.passwordForm.reset();
//   }
//   showSuccess(mensaje: string): void {
//     this.messageService.add({
//       severity: 'success',
//       summary: 'Éxito',
//       detail: mensaje
//     });
//   }

//   showError(mensaje: string): void {
//     this.messageService.add({
//       severity: 'error',
//       summary: 'Error',
//       detail: mensaje
//     });
//   }
//   get f() {
//     return this.passwordForm.controls;
//   }
// }
import { Component } from '@angular/core';
import { MessageService, ConfirmationService, ConfirmEventType } from 'primeng/api';
import { Paginar } from 'src/app/models/http-paginacion.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BusqUsuario, HttpPaginacionBusqueda } from 'src/app/models/http-paginacion-busqueda.interface';
import { Router } from '@angular/router'; // ✅ IMPORTAR Router

@Component({
  selector: 'app-administrador-usuarios',
  templateUrl: './administrador-usuarios.component.html',
  styleUrls: ['./administrador-usuarios.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class AdministradorUsuariosComponent {
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 120;

  // ✅ Para todos los usuarios (ruta: api/usuarios)
  // usuariosPageInformacion: HttpPaginacion<UsuarioSesion> | undefined;
  //usuariosPage: UsuarioSesion[] = [];

  // ✅ Para resultados de búsqueda (ruta: api/operativos/buscar/usuario)
  usuariosPageInformacion: HttpPaginacionBusqueda<BusqUsuario> | undefined;
  usuariosPage: BusqUsuario[] = [];

  // ✅ Controlar qué tabla mostrar
  modoBusqueda: boolean = false;

  passwordForm!: FormGroup;
  busquedaForm!: FormGroup;
  showModalPassword: boolean = false;

  constructor(
    private administradorService: AdministradorService,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router  // ✅ Inyectar Router
  ) {
    // Cargar todos los usuarios al iniciar
    //   this.obtenerInformacion(1);

    this.passwordForm = this.crearFormulario();
    this.busquedaForm = this.createFormularioBusqueda();
    this.obtenerInformacionUsuario(1);
  }

  crearFormulario(): FormGroup {
    return this.fb.group({
      nuevo_password: [null, Validators.required],
      id: [null]
    });
  }

  createFormularioBusqueda(): FormGroup {
    return this.fb.group({
      usuario: [null],
      nombre: [null],
      apellido_paterno: [null],
      apellido_materno: [null],
    });
  }

  onSubmitPassword(): void {
    let id = this.f['id'].value;
    let nueva = this.f['nuevo_password'].value;
    this.administradorService.setCambiarPassword(id, nueva).subscribe({
      next: (resp) => {
        this.showSuccess(resp.mensaje);
        this.cancelarAccion();
      },
      error: (err) => {
        this.showError(err.error.message);
      }
    });
  }
  /*
    // ✅ Obtener todos los usuarios
    obtenerInformacion(page: number): void {
      this.modoBusqueda = false;
      this.administradorService.usuarios(page)
        .subscribe({
          next: (resp) => {
            this.usuariosPageInformacion = resp;
            this.usuariosPage = resp.data;
  
            this.first = (resp.current_page - 1) * resp.per_page;
            this.rows = resp.per_page;
            this.totalRecords = resp.total;
          },
          error: (err) => console.log(err)
        });
    }
  */
  // ✅ Búsqueda de usuarios
  onSubmitBusqueda(): void {
    this.modoBusqueda = true;
    this.obtenerInformacionUsuario(1);
  }

  obtenerInformacionUsuario(page: number): void {
    const busqueda = this.busquedaForm.value;
    this.administradorService.busquedaUsuarios(busqueda, page)
      .subscribe({
        next: (resp) => {
          this.usuariosPageInformacion = resp;
          this.usuariosPage = resp.data;
          this.first = (resp.current_page - 1) * resp.per_page;
          this.rows = resp.per_page;
          this.totalRecords = resp.total;
        },
        error: (err) => console.log(err)
      });
  }

  // ✅ Manejar cambio de página
  onPageChange(event: any): void {
    const paginar: Paginar = <Paginar>event;
    const paginaActual = paginar.page + 1;
    this.obtenerInformacionUsuario(paginaActual);
    /*
    if (this.modoBusqueda) {
     
    } else {
      this.obtenerInformacion(paginaActual);
    }*/
  }

  // ✅ Navegar al detalle del usuario
  verDetalleUsuario(id: number): void {
    this.router.navigate(['/administrador/usuario', id]);
  }

  actualizarUsuario(usuario: BusqUsuario): void {
    if (usuario.medico) {
      this.router.navigate(['/administrador/usuario/actualizar', 'medico', usuario.medico.id]);
      return;
    }

    if (usuario.enfermera) {
      this.router.navigate(['/administrador/usuario/actualizar', 'enfermera', usuario.enfermera.id]);
      return;
    }

    if (usuario.supervisor) {
      this.router.navigate(['/administrador/usuario/actualizar', 'supervisor', usuario.supervisor.id]);
      return;
    }

    this.showError('Solo se pueden actualizar medicos, enfermeras y supervisores');
  }

  confirmacion(usuario: BusqUsuario): void {
    if (usuario.activo === 1) { this.confirmacionDesactivar(usuario); }
    else { this.confirmacionActivar(usuario); }
  }

  confirmacionDesactivar(usuario: BusqUsuario): void {
    this.confirmationService.confirm({
      message: `Estas seguro que quieres desactivar a ${usuario.nom_completo}`,
      header: 'Confirmacion',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.administradorService.desactivarUsuario(usuario.id).subscribe({
          next: (resp) => {
            usuario.activo = 0;
            this.messageService.add({ severity: 'info', summary: 'Confirmacion', detail: resp.mensaje });
          },
          error: (err: HttpErrorResponse) => {
            this.messageService.add({ severity: 'error', summary: 'Rechazada', detail: err.error.message });
          }
        });
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({ severity: 'error', summary: 'Rechazada', detail: 'Confirmacion rechazada' });
            break;
          case ConfirmEventType.CANCEL:
            this.messageService.add({ severity: 'warn', summary: 'Cancelada', detail: 'Opcion Cancelada' });
            break;
        }
      }
    });
  }

  confirmacionActivar(usuario: BusqUsuario): void {
    this.confirmationService.confirm({
      message: `Estas seguro que quieres activar a ${usuario.nom_completo}`,
      header: 'Confirmacion',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.administradorService.activarUsuario(usuario.id).subscribe({
          next: (resp) => {
            usuario.activo = 1;
            this.messageService.add({ severity: 'info', summary: 'Confirmacion', detail: resp.mensaje });
          },
          error: (err: HttpErrorResponse) => {
            this.messageService.add({ severity: 'error', summary: 'Rechazada', detail: err.error.message });
          }
        });
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({ severity: 'error', summary: 'Rechazada', detail: 'Confirmacion rechazada' });
            break;
          case ConfirmEventType.CANCEL:
            this.messageService.add({ severity: 'warn', summary: 'Cancelada', detail: 'Opcion Cancelada' });
            break;
        }
      }
    });
  }


  cambiarPassword(usuario: BusqUsuario): void {
    this.openModal();
    this.f['id'].setValue(usuario.id);
  }

  cancelarAccion(): void {
    this.resetForm();
    this.closeModal();
  }

  closeModal(): void {
    this.showModalPassword = false;
  }

  openModal(): void {
    this.showModalPassword = true;
  }

  resetForm(): void {
    this.passwordForm.reset();
  }

  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }

  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }

  get f() {
    return this.passwordForm.controls;
  }
}
